import React from 'react';

import oneonone from "./images/oneonone.png"
import collab from "./images/collaboration.jpg"
import learn from "./images/learn.jpg"

import './styles/dashboard.css';

export default class About extends React.Component {
    render() {
        return (
            <div className="row-fluid">
                <img src={oneonone} className="img-fluid"></img><br></br><br></br>
                <p>
                    On SkillEd, you can make new friends and learn new skills along the way. You can also mentor others in things you are good at. With SkillEd, we bring the personal touch to skill sharing. 
                </p>
                <div className="row" style={{textAlign:"left"}}>
                    <div className="col"><img src={collab} className="img-fluid"></img></div>
                    <div className="col">
                        <h1>Meet</h1>
                        <p>Meet new people with diverse skills. No black mirrors, only real world interactions.</p>
                    </div>
                    <div className="col"><img src={learn} className="img-fluid"></img></div>
                    <div className="col">
                        <h1>Learn</h1>
                        <p>Learn or teach new skills in one on one meetings. Earn SkillEd platform credits as you go.</p>
                    </div>
                </div>
                <br></br>
                {/* <hr></hr> */}
                <br></br>
                <h2>How SkillEd Works</h2>
                <div className="row-fluid">
                    <div className="row" style={{marginTop:"50px"}}>
                        <div className="col-sm-2" style={{color:"#2b8cbe"}}><i className="fa fa-brain big"></i></div>
                        <div className="col-sm-10">
                            <h4>Discover Masters</h4>
                            <p>See who’s mastered the things you want to learn</p>
                        </div>
                    </div>
                    <div className="row" style={{marginTop:"50px"}}>
                        <div className="col-sm-2" style={{color:"#dd1c77"}}><i className="fa fa-graduation-cap big"></i></div>
                        <div className="col-sm-10">
                            <h4>Acquire Skills</h4>
                            <p>Set up one on one meetings with masters, learn new skills</p>
                        </div>
                    </div>
                    <div className="row" style={{marginTop:"50px"}}>
                        <div className="col-sm-2" style={{color:"#31a354"}}><i className="fa fa-search big"></i></div>
                        <div className="col-sm-10">
                            <h4>Discover Learners</h4>
                            <p>Find people who want to learn things you are good at</p>
                        </div>
                    </div>
                    <div className="row" style={{marginTop:"50px"}}>
                        <div className="col-sm-2" style={{color:"#8856a7"}}><i className="fa fa-hands-helping big"></i></div>
                        <div className="col-sm-10">
                            <h4>Impart Knowledge</h4>
                            <p>Share your knowledge with the world, in the real world</p>
                        </div>
                    </div>
                    <div className="row" style={{marginTop:"50px"}}>
                        <div className="col-sm-2" style={{color:"#feb24c"}}><i className="fa fa-coins big"></i></div>
                        <div className="col-sm-10">
                            <h4>Earn Credits</h4>
                            <p>Earn credits by mentoring others, use credits to learn new skills</p>
                        </div>
                    </div>
                </div>
                <br></br><br></br><br></br>
            </div>

        );
    }
}